import { render, staticRenderFns } from "./imagePreview.vue?vue&type=template&id=4db35b3f&scoped=true"
import script from "./imagePreview.vue?vue&type=script&lang=js"
export * from "./imagePreview.vue?vue&type=script&lang=js"
import style0 from "./imagePreview.vue?vue&type=style&index=0&id=4db35b3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db35b3f",
  null
  
)

export default component.exports